import React, { useEffect, useState } from "react";
import api from "../../services/api";

export default function NotificationsDrawer({ open, onClose }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const res = await api.get("/notifications");
      setNotifications(res?.data?.items || []);
    } catch {
      // fallback mock notifications if empty
      setNotifications([
        {
          id: 1,
          title: "Beba mais água 💧",
          message: "Mantenha sua meta diária de hidratação para um dia leve e com energia.",
          read: false,
          createdAt: new Date().toISOString(),
        },
        {
          id: 2,
          title: "Horário da Medicação 💊",
          message: "Lembre-se de registrar sua dose programada de hoje no MariaM.",
          read: false,
          createdAt: new Date().toISOString(),
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchNotifications();
    }
  }, [open]);

  const markAllAsRead = async () => {
    try {
      await api.put("/notifications/read-all");
      setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
    } catch {
      setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
    }
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100000] flex justify-end bg-black/50 backdrop-blur-xs animate-in fade-in duration-200"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="w-full max-w-md h-full bg-[#F8F6FD] shadow-2xl flex flex-col sm:rounded-l-[32px] overflow-hidden animate-in slide-in-from-right duration-300">
        {/* CABEÇALHO HERO COM IDENTIDADE OFICIAL */}
        <div className="p-5 bg-gradient-to-br from-[#421F97] via-[#2E146E] to-[#1D0A4C] text-white flex items-center justify-between shadow-md relative overflow-hidden flex-shrink-0">
          <div className="absolute -right-6 -bottom-6 h-28 w-28 rounded-full bg-purple-400/20 blur-xl pointer-events-none" />
          
          <div className="relative z-10 flex items-center gap-3">
            <div className="w-11 h-11 rounded-2xl bg-white/15 backdrop-blur-md border border-white/20 flex items-center justify-center text-xl shadow-inner">
              🔔
            </div>
            <div>
              <h2 className="text-base font-black tracking-tight text-white leading-tight">
                Central de Avisos
              </h2>
              <p className="text-[11px] font-medium text-purple-200 mt-0.5">
                Lembretes & alertas de saúde prioritários
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="relative z-10 w-9 h-9 rounded-2xl bg-white/15 hover:bg-white/25 border border-white/20 text-white flex items-center justify-center font-black transition-all active:scale-95 cursor-pointer shadow-xs"
            title="Fechar"
          >
            ✕
          </button>
        </div>

        {/* SUB-BARRA DE AÇÕES */}
        <div className="px-5 py-3 bg-white border-b border-purple-100 flex items-center justify-between flex-shrink-0">
          <div className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-[#6C54D8]" />
            <span className="text-[11px] font-black text-gray-900 uppercase tracking-wider">
              Notificações Recentes
            </span>
          </div>
          <button
            type="button"
            onClick={markAllAsRead}
            className="text-[11px] font-bold text-[#5B38C2] hover:text-[#421F97] bg-purple-50 hover:bg-purple-100 px-2.5 py-1 rounded-xl transition active:scale-95 cursor-pointer"
          >
            Marcar lidas
          </button>
        </div>

        {/* LISTA DE NOTIFICAÇÕES */}
        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {loading ? (
            <div className="space-y-3 py-4 animate-pulse">
              <div className="h-20 rounded-3xl bg-purple-100 w-full" />
              <div className="h-20 rounded-3xl bg-purple-100 w-full" />
            </div>
          ) : notifications.length === 0 ? (
            <div className="p-8 text-center border border-dashed border-purple-200 rounded-3xl bg-white shadow-xs my-auto">
              <div className="w-14 h-14 rounded-2xl bg-purple-50 flex items-center justify-center text-2xl mx-auto mb-3">
                ✨
              </div>
              <h4 className="text-sm font-black text-gray-900 leading-tight">
                Você não possui novos avisos.
              </h4>
              <p className="text-xs text-gray-500 mt-1 max-w-xs mx-auto">
                Tudo em dia com a sua saúde e rotina de cuidados!
              </p>
            </div>
          ) : (
            notifications.map((item) => (
              <div
                key={item.id}
                className={`p-4 rounded-3xl border transition-all duration-200 ${
                  item.read
                    ? "bg-white border-purple-100/70 text-gray-600 shadow-2xs"
                    : "bg-white border-purple-200 text-[#1E192B] shadow-sm ring-1 ring-purple-400/20"
                }`}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="flex items-center gap-2">
                    <span
                      className={`w-2 h-2 rounded-full ${
                        item.read ? "bg-gray-300" : "bg-emerald-500 animate-pulse"
                      }`}
                    />
                    <h4 className="text-xs font-black text-gray-900 leading-tight">
                      {item.title}
                    </h4>
                  </div>
                  {!item.read && (
                    <span className="px-2 py-0.5 rounded-md bg-purple-100 text-purple-800 text-[9px] font-black uppercase tracking-wider">
                      NOVO
                    </span>
                  )}
                </div>
                <p className="mt-2 text-xs leading-relaxed text-gray-600 font-medium">
                  {item.message}
                </p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
